import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import clsx from 'clsx'

export type DividerProps = {
  dividerClassName?: string
}

const useStyles = makeStyles({
  divider: {
    border: `1px dashed ${mutualTheme.palette.grey[400]}`,
    marginBottom: mutualTheme.spacing(3),
    marginTop: mutualTheme.spacing(3)
  }
})

export const Divider: React.FC<DividerProps> = (props) => {
  const { dividerClassName } = props
  const classes = useStyles()

  return <hr className={clsx(classes.divider, dividerClassName)} />
}
